import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { gql } from '@apollo/client'
import { MASTER_CASE_LIST_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getTenant } from '../../../utils'
import { getData } from '../CustomUtils'
import PDFLink from '../../PDFLink/PDFLink'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import FormHeading from '../FormHeading.js'

const MASTER_CASE_LIST = gql(MASTER_CASE_LIST_QUERY)

export default function MasterCaseList() {
  console.log('MasterCaseList rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(null, MASTER_CASE_LIST, 'masterCaseList', setResults, setGraphQLErrors)
  }, [])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let resultRows = []
    let rowNum = 0
    for (let resultRow of results.reportData) {
      const row = []
      for (let col = 0; col < resultRow.length; col++) {
        if (col === resultRow.length - 1) {
          row.push(<td key={col}><Link to={`/custom/reports.active_case_full_report?caseId=${resultRow[col]}`} target="_blank">Summary</Link></td>)
        } else {
          row.push(<td key={col}>{resultRow[col]}</td>)
        }
      }
      resultRows.push(<tr key={rowNum}>{row}</tr>)
      rowNum++
    }

    const pdfUrl = `${process.env.REACT_APP_SERVER}/pdf/${getTenant()}/custom/CatEast/masterCaseListPDF/master_case_list`
  
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
          <PDFLink url={pdfUrl} />
        </div>
        <Table bordered className="custom-table">
          <FormHeading headingText='Master Case List (non-asbestos)' colSpan='14' />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}